import React, { Component } from 'react';

import PropTypes from 'prop-types';

import {connect} from "react-redux";
import parentStyles from "../ReviewOrder.module.css";
import styles from "./Discounts.module.css";
import { getCheckoutPartProps, isReviewOrderBrandRefresh } from "../reviewOrderBrandRefreshClasses";
import {handleFormInput} from "../../../shared/utilities/validations";
import * as tagmanagerEvents from '../../../shared/utilities/tagmanagerEvents';
import Loader from "../../../components/Loader/Loader";
import ReCAPTCHAForm from "../../../components/ReCaptcha/ReCaptcha";
import * as orderRepo from "../../../shared/repos/graphql/order";
import * as orderActions from "../../../redux/actions/order";
import * as paymentActions from '../../../redux/actions/payment';
import * as elementsActions from "../../../redux/actions/elements";
import { orderTypeIds, paymentMethodIds, totalTitles, groupTitles } from '../../../shared/constants/order';
import { defaultCurrency } from '../../../shared/constants/currency';
import errorCodes from '../../../shared/constants/errorCodes';
import captchaAction from '../../../shared/constants/captchaAction';
import amplitudeAnalytics from '../../../shared/utilities/amplitude';
import { getErrorReasons } from '../../../shared/utilities/common';
import { setCaptchaToken } from '../../../shared/utilities/captcha';
import {
  classifyPromoInput,
  formatAmplitudeCheckoutSavings,
  getAddedDiscountLines,
  splitDiscountLinesForAmplitude,
} from '../../../shared/utilities/amplitudeCheckoutAnalytics';

const clearIcon = require('../../../components/DeliveryPickUpWidget/imgs/clear-dark-icon.svg');
const clearLightIcon = require('../../../components/DeliveryPickUpWidget/imgs/clear-light-icon.svg');
const tagIcon = require('../imgs/tag.svg');
const tagLightIcon = require('../imgs/tag-light.svg');
const brandRefreshPromoTagIcon = require('../imgs/brand-refresh/promo-tag.svg');
const brandRefreshPromoCloseIcon = require('../imgs/brand-refresh/promo-tag-close.svg');
const brandRefreshFieldErrorInfo = require('../../../components/PaymentWidget/PaymentInputs/PaymentInputCreditCardLegacy/imgs/brand-refresh-field-error-info.svg');

const ADD_DISCOUNT_RATE_LIMITED_MESSAGE = 'Too many attempts. Please try again later.';
const ADD_DISCOUNT_CAPTCHA_FAILED_MESSAGE = 'The captcha was not entered correctly. Please try again.';

class Discounts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promoCode: '',
            promoCodes: [],
            promoError: '',
            promoResultLoading: false,
            promoRemovalLoading: false,
            showCaptchaChallenge: false,
            captchaKey: 0,
            invisibleCaptchaAttempted: false,
        };
        this.recaptchaComponentRef = React.createRef();
    }

    componentDidMount() {
        this.initializeDiscounts();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.initializeDiscounts();
        }
    }

    setPaymentCredentials = () => {
        const { order, setPaymentCredentials, paymentCredentials } = this.props;
        const { promoCodes } = this.state;

        const total = order.totals.find(ttl => ttl.title === totalTitles.total);

        let paymentCredentialsExists = false;
        if (
            paymentCredentials &&
            parseInt(paymentMethodIds.giftcard, 10) === parseInt(paymentCredentials.paymentMethodId, 10) &&
            paymentCredentials.credential === promoCodes[0]
        ) {
            paymentCredentialsExists = true;
        }

        if (total.value === 0 && !paymentCredentialsExists && !this.isDoughProOrder())  {
            setPaymentCredentials({
                paymentMethodId: paymentMethodIds.giftcard,
                credential: promoCodes[0]
            });
        }
    }

    setDiscounts(order) {
        const updatedPromos = [];

        if( order.discounts && order.discounts.length > 0) {
            order.discounts.forEach((cartTotal) => {
                let {title} = cartTotal;
                title = title.replace('Coupon: ', '');
                title = title.replace('Giftcard: ', '');

                updatedPromos.push(title);
            });
            tagmanagerEvents.applyPromo(order?.code, order.discounts, order?.customer?.id)
        }

        this.setState({
            promoCodes: updatedPromos
        }, () => {
            this.setPaymentCredentials();
        });
    }

    isDoughProOrder = () => {
        const {order} = this.props;

        return orderTypeIds.doughPro === parseInt(order.orderTypeId, 10);
    }

    getOrderParams = () => {
        const { paymentCredentials } = this.props;
        if (paymentCredentials) {
            return {
                paymentCredential: paymentCredentials
            };
        }
        return null;
    }

    handleAddDiscountSuccess = (response, attemptedTrim, prevDiscounts) => {
        const { order } = this.props;
        const newOrder = this.extractNewTotals(order, response.data.addDiscountToOrder);

        this.setState({
            promoCode: ' ',
            promoError: false,
            promoResultLoading: false,
            showCaptchaChallenge: false,
            invisibleCaptchaAttempted: false,
        });

        this.emitEnterPromoCodeGiftCardEvent(
            true,
            attemptedTrim,
            prevDiscounts,
            response.data.addDiscountToOrder
        );
        this.setDiscounts(newOrder);
    }

    showCheckboxCaptcha = (promoError = ADD_DISCOUNT_CAPTCHA_FAILED_MESSAGE) => {
        this.setState(prevState => ({
            promoError,
            promoResultLoading: false,
            showCaptchaChallenge: true,
            captchaKey: prevState.captchaKey + 1,
        }));
    }

    clearVerificationHeaders = () => {
        const { setVerificationToken, setVerificationAction, setVerificationProvider } = this.props;
        setVerificationToken('');
        setVerificationAction('');
        setVerificationProvider('');
    }

    retryWithInvisibleCaptcha = async (attemptedTrim, prevDiscounts) => {
        const { setVerificationToken, setVerificationAction } = this.props;

        this.setState({
            promoError: '',
            promoResultLoading: true,
            showCaptchaChallenge: false,
            invisibleCaptchaAttempted: true,
        });

        try {
            // Invisible token is sent via verification-* headers only.
            await setCaptchaToken(
                setVerificationToken,
                setVerificationAction,
                captchaAction.addDiscount
            );
            await this.applyDiscount(null, { emitAmplitudeOnError: true });
        } catch (error) {
            this.emitEnterPromoCodeGiftCardEvent(false, attemptedTrim, prevDiscounts, null);
            this.showCheckboxCaptcha('');
        }
    }

    handleAddDiscountError = (reason, attemptedTrim, prevDiscounts, emitAmplitude = true) => {
        const errorReason = getErrorReasons(reason, 0);
        const gqlErr = reason?.graphQLErrors?.[0];
        const message = gqlErr?.message || 'Unknown error';
        const { invisibleCaptchaAttempted } = this.state;

        if (errorReason === errorCodes.ADD_DISCOUNT_CAPTCHA_REQUIRED) {
            if (invisibleCaptchaAttempted) {
                if (emitAmplitude) {
                    this.emitEnterPromoCodeGiftCardEvent(false, attemptedTrim, prevDiscounts, null);
                }
                this.showCheckboxCaptcha('');
                return Promise.resolve();
            }
            return this.retryWithInvisibleCaptcha(attemptedTrim, prevDiscounts);
        }

        if (emitAmplitude) {
            this.emitEnterPromoCodeGiftCardEvent(false, attemptedTrim, prevDiscounts, null);
        }

        if (errorReason === errorCodes.ADD_DISCOUNT_CAPTCHA_FAILED) {
            this.showCheckboxCaptcha(ADD_DISCOUNT_CAPTCHA_FAILED_MESSAGE);
            return Promise.resolve();
        }

        if (errorReason === errorCodes.ADD_DISCOUNT_RATE_LIMITED) {
            this.setState({
                promoError: ADD_DISCOUNT_RATE_LIMITED_MESSAGE,
                promoResultLoading: false,
                showCaptchaChallenge: false,
            });
            return Promise.resolve();
        }

        this.setState({
            promoError: message,
            promoResultLoading: false,
            showCaptchaChallenge: false,
        });
        return Promise.resolve();
    }

    applyDiscount = (gRepcaptchaResponse = null, { emitAmplitudeOnError = true } = {}) => {
        const { promoCode } = this.state;
        const { order } = this.props;
        const orderParams = this.getOrderParams();
        const prevDiscounts = [...(order?.discounts || [])];
        const attemptedTrim = String(promoCode).trim();

        if (!attemptedTrim) {
            this.setState({
                promoError: 'Field cannot be empty.',
                promoResultLoading: false,
                showCaptchaChallenge: false,
            });
            return Promise.resolve();
        }

        return orderRepo.addGiftcardOrPromotion(
            order.code,
            [attemptedTrim],
            orderParams,
            gRepcaptchaResponse
        ).then((response) => {
            this.clearVerificationHeaders();
            this.handleAddDiscountSuccess(response, attemptedTrim, prevDiscounts);
        }).catch(reason => {
            this.clearVerificationHeaders();
            return this.handleAddDiscountError(reason, attemptedTrim, prevDiscounts, emitAmplitudeOnError);
        });
    }

    onVerifyCaptcha = (token) => {
        if (!token) {
            return;
        }

        const { promoCode } = this.state;
        if (!String(promoCode).trim()) {
            this.setState({
                promoError: 'Field cannot be empty.',
                promoResultLoading: false,
                showCaptchaChallenge: false,
            });
            return;
        }

        // Checkbox token is sent only as gRepcaptchaResponse (not verification-* headers).
        this.setState({
            promoResultLoading: true,
            showCaptchaChallenge: false,
            promoError: '',
        });

        this.applyDiscount(token, { emitAmplitudeOnError: true });
    }

    handlePromoSubmission() {
        const { promoCode, promoResultLoading } = this.state;
        const { order } = this.props;

        if (promoResultLoading) {
            return;
        }

        if (!String(promoCode).trim()) {
            this.emitEnterPromoCodeGiftCardEvent(false, '', order?.discounts, null);
            this.setState({ promoError: 'Field cannot be empty.', showCaptchaChallenge: false });
            return;
        }

        this.setState({
            promoResultLoading: true,
            showCaptchaChallenge: false,
            invisibleCaptchaAttempted: false,
        });

        this.applyDiscount(null);
    };

    initializeDiscounts() {
        const { order } = this.props;

        if (order) {
            this.setDiscounts(order);
        }
    }

    /**
     * Amplitude — fire on Apply (success or failure).
     */
    emitEnterPromoCodeGiftCardEvent(isAccepted, attemptedRaw, prevDiscounts, addDiscountPayload) {
        const { currency } = this.props;
        const currencySafe = currency || defaultCurrency;
        const zeroSavings = formatAmplitudeCheckoutSavings(currencySafe, 0);
        const attempted = String(attemptedRaw || '').trim();

        if (!isAccepted && !attempted) {
            amplitudeAnalytics.trackEnterPromoCodeGiftCard({
                isAccepted: false,
                coupon: '',
                couponSavings: zeroSavings,
                giftCardNumbers: '',
                giftCardSavings: zeroSavings,
            });
            return;
        }

        if (!isAccepted) {
            const { treatAsGiftCard } = classifyPromoInput(attempted);
            amplitudeAnalytics.trackEnterPromoCodeGiftCard({
                isAccepted: false,
                coupon: treatAsGiftCard ? '' : attempted,
                couponSavings: zeroSavings,
                giftCardNumbers: treatAsGiftCard ? attempted : '',
                giftCardSavings: zeroSavings,
            });
            return;
        }

        const nextDiscounts = addDiscountPayload?.discounts || [];
        const added = getAddedDiscountLines(prevDiscounts, nextDiscounts);
        const split = splitDiscountLinesForAmplitude(added);
        amplitudeAnalytics.trackEnterPromoCodeGiftCard({
            isAccepted: true,
            coupon: split.couponCodes.join(', '),
            couponSavings: formatAmplitudeCheckoutSavings(currencySafe, split.couponSavings),
            giftCardNumbers: split.giftCardNumbers.join(', '),
            giftCardSavings: formatAmplitudeCheckoutSavings(currencySafe, split.giftCardSavings),
        });
    }

    removeDiscount(discountCode) {
        const { order, setPaymentCredentials, paymentCredentials } = this.props;

        this.setState({ promoRemovalLoading: true });

        let orderParams = null;
        if (paymentCredentials) {
          orderParams = {
            paymentCredential: paymentCredentials
          }
        }

        orderRepo.removeDiscount(order.code, discountCode, orderParams).then((response) => {
            const newOrder = this.extractNewTotals(order, response.data.removeDiscountFromOrder);

            this.setState({
                promoRemovalLoading: false
            });

            this.setDiscounts(newOrder);

            setPaymentCredentials(null);
        }).catch(reason => {
            this.setState({ promoError: reason.graphQLErrors[0].message, promoResultLoading: false });

            setPaymentCredentials(null);
        });
    }

    handlePromoCodeRendering() {
        const { promoCodes, promoRemovalLoading } = this.state;
        const brandRefresh = isReviewOrderBrandRefresh();

        return promoCodes.map(code => {
          if (brandRefresh) {
            return (
              <div
                key={code}
                className={styles.brandRefreshPromoChip}
                data-part={getCheckoutPartProps('promo-chip')}
              >
                {promoRemovalLoading ? (
                  <span className={styles.inputLoaderContainer}>
                    <Loader height={25} id="promo_removal_loader" />
                  </span>
                ) : (
                  <>
                    <img
                      alt=""
                      src={brandRefreshPromoTagIcon}
                      width={16}
                      height={16}
                      aria-hidden="true"
                    />
                    <span className={styles.brandRefreshPromoCode}>{code}</span>
                    <button
                      onClick={() => this.removeDiscount(code)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.removeDiscount(code);
                        }
                      }}
                      aria-label={`Remove Discount ${code}`}
                      type="button"
                      className={styles.brandRefreshPromoClose}
                    >
                      <img
                        alt=""
                        src={brandRefreshPromoCloseIcon}
                        width={16}
                        height={16}
                        aria-hidden="true"
                      />
                    </button>
                  </>
                )}
              </div>
            );
          }

          return (
          <div
            key={code}
            className={[
              parentStyles.discountContainer,
              styles.appliedDiscount,
              parentStyles.disableInput
            ].join(" ")}
          >
            <input
              disabled
              value={code}
              className="inputDarkModeOverride bg-transparent hidden"
            />
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            {promoRemovalLoading ? (
              <span className={styles.inputLoaderContainer}>
                <Loader height={25} id="promo_removal_loader" />
              </span>
            ) : (
              <div className="flex gap-1 max-w-full min-w-[153px] h-8 rounded-[40px] px-2 py-2 border-[1px] border-dark dark:border-white text-dark dark:text-white">

                <img
                  alt=""
                  src={tagIcon}
                  id="discount_tag"
                  className={`${parentStyles.clearImg} block dark:hidden top-0 w-4 h-4 flex-none`}
                />
                <img

                  alt=""
                  src={tagLightIcon}
                  id="discount_tag"
                  className={`${parentStyles.clearImg} hidden dark:block top-0 w-4 h-4 flex-none`}
                />

                <p className='text-sm font-montserratMedium font-[425] h-11 rounded-[40px]'>
                  {code}
                </p>

                <div className='flex-initial'>
                  <button
                    onClick={() => this.removeDiscount(code)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.removeDiscount(code);
                      }
                    }}
                    aria-label={`Remove Discount ${code}`}
                    type="button"
                    className={`${parentStyles.clearImg} block dark:hidden top-0 w-4 h-4 bg-transparent border-none p-0 cursor-pointer`}
                  >
                    <img
                      alt=""
                      src={clearIcon}
                      aria-hidden="true"
                    />
                  </button>
                  <button
                    onClick={() => this.removeDiscount(code)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.removeDiscount(code);
                      }
                    }}
                    aria-label={`Remove Discount ${code}`}
                    type="button"
                    className={`${parentStyles.clearImg} hidden dark:block top-0 w-4 h-4 bg-transparent border-none p-0 cursor-pointer`}
                  >
                    <img
                      alt=""
                      src={clearLightIcon}
                      aria-hidden="true"
                    />
                  </button>
                </div>


              </div>
            )}
          </div>
          );
        });
    };

    // eslint-disable-next-line class-methods-use-this
    extractNewTotals(order, orderTotals) {
        const newOrder = {
            ...order,
            discounts: [...orderTotals.discounts],
            totals: orderTotals.totals
        };
return newOrder; }

 renderDiscountsContainer = () => {
        const {
            promoCode,
            promoCodes,
            promoResultLoading,
            promoError,
            showCaptchaChallenge,
            captchaKey,
        } = this.state;

        const errorId = 'promo-code-error';
        const brandRefresh = isReviewOrderBrandRefresh();
        const hasPromoError = Boolean(promoError);

        const promoInput = (
          <input
            id="promo-code-input"
            value={promoCode}
            onChange={(e) => handleFormInput(e, this, 'promoCode')}
            placeholder={brandRefresh ? "Enter code" : "Enter code or number"}
            aria-invalid={hasPromoError ? true : undefined}
            aria-describedby={hasPromoError ? errorId : undefined}
            data-part={getCheckoutPartProps("promo-input")}
            className={
              brandRefresh
                ? [
                  styles.brandRefreshPromoInput,
                  hasPromoError ? styles.brandRefreshPromoInputHasError : null,
                ].filter(Boolean).join(' ')
                : `${styles.inputContainer}
                font-montserratMedium font-[425] h-11 rounded-[40px]
                border-[1px] border-lightDry dark:border-darkDry text-dark dark:text-white
                outline-none px-4 placeholder-dark dark:placeholder-white bg-transparent
                w-full inputDarkModeOverride
                `
            }
          />
        );

        const brandRefreshPromoError = hasPromoError && brandRefresh ? (
          <div
            id={errorId}
            className={styles.brandRefreshPromoErrorRow}
            role="alert"
            data-part={getCheckoutPartProps('promo-error')}
          >
            <img
              className={styles.brandRefreshPromoErrorInfo}
              src={brandRefreshFieldErrorInfo}
              alt=""
              aria-hidden="true"
            />
            <p className={styles.brandRefreshPromoErrorText}>{promoError}</p>
          </div>
        ) : null;

        const legacyPromoError = hasPromoError && !brandRefresh ? (
          <p
            id={errorId}
            className={styles.promoError}
            role="alert"
          >
            {promoError}
          </p>
        ) : null;

        const promoApplyButton = (
          <button
            id="btn_handle_promo_submit"
            className={
              brandRefresh
                ? styles.brandRefreshPromoApply
                : `${styles.submitButton} h-11 rounded-[40px] bg-dark dark:bg-button text-white font-montserratBold`
            }
            onClick={() => this.handlePromoSubmission()}
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.handlePromoSubmission();
              }
            }}
            type="button"
            aria-label="Apply promotion or gift card code"
            data-part={getCheckoutPartProps("promo-apply")}
          >
            {promoResultLoading ? (<Loader height={25} id="location_loader" />): "Apply"}
          </button>
        );

        const promoRow = brandRefresh ? (
          <div
            className={styles.discountsInputRow}
            data-part={getCheckoutPartProps("promo-row")}
          >
            <div
              className={styles.brandRefreshPromoField}
              data-part={getCheckoutPartProps('promo-input-field')}
            >
              {promoInput}
              {brandRefreshPromoError}
            </div>
            {promoApplyButton}
          </div>
        ) : (
          <div
            className={`${styles.discountsInputRow} flex gap-2 mt-2`}
            data-part={getCheckoutPartProps("promo-row")}
          >
            {promoInput}
            {promoApplyButton}
          </div>
        );

        const promoExtras = (
          <>
            {legacyPromoError}
            {showCaptchaChallenge && (
              <div className={styles.captchaContainer} data-testid="promo-captcha-challenge">
                <div className={styles.captchaScaler}>
                  <ReCAPTCHAForm
                    key={captchaKey}
                    ref={this.recaptchaComponentRef}
                    setToken={this.onVerifyCaptcha}
                  />
                </div>
              </div>
            )}
            {promoCodes.length > 0 ? this.handlePromoCodeRendering() : null}
          </>
        );

        if (brandRefresh) {
          return (
            <div
              className={styles.brandRefreshPromoBody}
              data-part={getCheckoutPartProps("promo-body")}
            >
              <p
                className={styles.brandRefreshPromoTitle}
                data-part={getCheckoutPartProps("payment-subtitle")}
              >
                {groupTitles.giftCard}
              </p>
              {promoRow}
              {promoExtras}
            </div>
          );
        }

        return (
          <>
            {promoRow}
            {promoExtras}
          </>
        );
    }

    render() {
        return <this.renderDiscountsContainer />
    }
}

Discounts.propTypes = {
    order: PropTypes.shape().isRequired,
    setPaymentCredentials: PropTypes.func.isRequired,
    paymentCredentials: PropTypes.shape(),
    currency: PropTypes.shape({ symbol: PropTypes.string }),
    setVerificationToken: PropTypes.func.isRequired,
    setVerificationAction: PropTypes.func.isRequired,
    setVerificationProvider: PropTypes.func.isRequired,
};

Discounts.defaultProps = {
    paymentCredentials: null,
    currency: defaultCurrency,
};

export const mapStateToProps = (state) => {
    return {
        order: state.order,
        paymentCredentials: state.payment.credentials,
        currency: state.currency.currency,
    }
}

export const mapDispatchToProps = (dispatch) => ({
    orderUpdated: (value) => dispatch(orderActions.orderUpdated(value)),
    paymentCredentialsUpdated: (value) => dispatch(paymentActions.paymentCredentialsUpdated(value)),
    setVerificationToken: value => dispatch(elementsActions.setVerificationToken(value)),
    setVerificationAction: value => dispatch(elementsActions.setVerificationAction(value)),
    setVerificationProvider: value => dispatch(elementsActions.setVerificationProvider(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Discounts);
